import type { MessageKey } from '@/shared/lib/i18n';

/** i18n keys for the dual-word reveal surface (Flic / Infiltré). */
export const WORD_LABEL_KEYS: { readonly primary: MessageKey; readonly secondary: MessageKey } = {
  primary: 'round.flic_word',
  secondary: 'round.infiltre_word',
};
